import { render } from "./scanPayModal.vue?vue&type=template&id=a39c120c"
import script from "./scanPayModal.vue?vue&type=script&lang=js"
export * from "./scanPayModal.vue?vue&type=script&lang=js"

import "./scanPayModal.vue?vue&type=style&index=0&id=a39c120c&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__